export const SEND_CUTLERY_TEXT = "Send cutlery";
export const NUDGE_CUTLERY_TEXT = "Tap here if you need cutlery";

export const TOOLTIP_CROSS_ICON_COLOR = "#FFFFFF26";

export const TOOLTIP_POSITIONING = {
    TOP: 42,
    LEFT: 150,
};

export const TEXT_GAP = "6px";
